// src/features/carousel/components/CarouselListItem.js
import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';

// अपने Carousel API हुक्स को इंपोर्ट करें
import { useGetAllCarouselItemsQuery, useDeleteCarouselItemMutation } from '../services/carouselApi';

const CarouselListItem = ({ carouselItemId, index }) => {
    // RTK Query के selectFromResult का उपयोग करके विशिष्ट आइटम प्राप्त करें
    const { carouselItem } = useGetAllCarouselItemsQuery('carouselList', {
        selectFromResult: ({ data }) => ({
            // सुनिश्चित करें कि आपका API response structure सही है (e.g., data.data for actual array)
            carouselItem: data?.data?.find(item => item._id === carouselItemId)
        }),
    });

    const [deleteCarouselItem, {
        isLoading: isDeleting,
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delError
    }] = useDeleteCarouselItemMutation();

    const navigate = useNavigate();

    const onDeleteItemClicked = async (id) => {
        // कन्फर्मेशन डायलॉग जोड़ने पर विचार करें
        if (window.confirm("Are you sure you want to delete this carousel item?")) {
            await deleteCarouselItem(id);
        }
    };

    if (carouselItem) {
        const handleEdit = () => navigate(`/dashboard/carousel/${carouselItem._id}`);

        return (
            <>
                <tr className="table__row">
                    <td className="table__cell">{index + 1}</td>
                    <td className="table__cell">{carouselItem.title}</td>
                    <td className="table__cell">{carouselItem.mediaType}</td>
                    <td className="table__cell">{carouselItem.isVisible ? 'Yes' : 'No'}</td>
                    <td className="table__cell">
                        <button
                            className="icon-button table__button"
                            onClick={handleEdit}
                        >
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </button>
                        <button
                            className="icon-button table__button"
                            onClick={() => onDeleteItemClicked(carouselItem._id)}
                            disabled={isDeleting}
                        >
                            <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                    </td>
                </tr>
                {isDelError && (
                    <tr>
                        <td colSpan={5} className="errmsg">
                            {delError?.data?.message || 'Failed to delete item.'}
                        </td>
                    </tr>
                )}
            </>
        );
    } else return null;
};

// परफ़ॉर्मेंस ऑप्टिमाइज़ेशन के लिए memo का उपयोग करें
const MemoizedCarouselListItem = memo(CarouselListItem);

export default MemoizedCarouselListItem;